export interface PaginatedResponse<T, C = null> {
  data: T[];
  context?: C;
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
}

// Use a type assertion for import.meta.env
export const API_BASE_URL =
  // @ts-expect-error: Vite-specific environment variable
  import.meta.env?.VITE_API_URL || "http://localhost:3001";

export interface ApiErrorData {
  error: string;
  details?: string;
  status?: number;
  serverError?: boolean;
}

/**
 * Custom error class for API errors
 * Example:
 * ```
 * throw new ApiError(
 *   "Failed to fetch user information", // message
 *   response, // response
 *   {
 *     error: "Failed to fetch user information", // data.error
 *     serverError: true // data.serverError
 *   }
 * );
 * ```
 */
export class ApiError extends Error {
  response?: Response;
  data?: ApiErrorData;

  constructor(message: string, response?: Response, data?: ApiErrorData) {
    super(message);
    this.name = "ApiError";
    this.response = response;
    this.data = data;
  }
}
